define.alias("shared/components/shared/wistia-video", "media/components/shared/wistia-video");